import React from "react";
import { Switch } from 'react-router-dom';
import { errorLayout } from '../../layouts/ErrorLayout';
import AppRoute from '../AppRoute';
import Loader from '../../helper/loaders';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import { auth } from '../../utils/authentication/auth';

const CreateProduct = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Products/CreateProduct')
);

const EditProduct = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Products/EditProduct')
);

const List = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Products/ManageProducts')
);

const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/not-found-page.component')
);


const AuthComponent = (props) => {
    let { match } = props;

    return (
        <React.Fragment>
            <Switch>

                <AppRoute
                    path={`${match.path}/create`}
                    component={CreateProduct}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Create Product'
                />

                <AppRoute
                    exact={true}
                    path={`${match.path}/edit/:id`}
                    component={EditProduct}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Edit Product'
                />

                <AppRoute
                    exact={true}
                    path={`${match.path}/list-all`}
                    component={List}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='All Products'
                />

                <AppRoute
                    path={`${match.path}/*`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

                <AppRoute
                    exact
                    path={`${match.path}`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </React.Fragment>
    )
};

export default AuthComponent;